import _isNil from 'lodash/isNil';

import { DELAY_DISABLED_VALUE } from './AnnouncementTiming.constants';

export function millisecondsToTimingInput(milliseconds) {
  return _isNil(milliseconds) ? DELAY_DISABLED_VALUE : Math.round(milliseconds / 1000);
}
